<template>

<div>

    <v-navigation-drawer :value="showNav" @input="drawer = $event" :mini-variant="mini && $vuetify.breakpoint.lgAndUp" :permanent="$vuetify.breakpoint.lgAndUp" app clipped left hide-overlay :style="navStyle" class="nav-drawer" :dark="globalDarkMode" :light="!globalDarkMode">

        <scrollable-content>

            <v-toolbar v-if="$vuetify.breakpoint.lgAndUp" dense :color="topBarColorString" dark slot="header">

                <!-- <v-btn v-if="!mini" small @click="editable = !editable" icon>
                    <v-icon size="16">{{editable ? "mdi-lock-open-variant" : "mdi-lock" }}</v-icon>
                </v-btn> -->
                <v-spacer v-if="!mini" />
                <v-btn icon @click.stop="mini = !mini">
                    <v-icon>{{ mini ? "mdi-chevron-double-right" : "mdi-chevron-double-left"}}</v-icon>
                </v-btn>
                <v-btn icon @click="hide()" small v-if="$vuetify.breakpoint.mdAndDown">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>
            <div style="padding:20px;" v-else>
                <logo/>
            </div>

            <div>

            
                <v-card color="transparent" tile flat>
                    <div v-for="(item, i) in this.nav" :key="`nav-default-items-${i}`"  style="margin-right:1px;" >

                        <v-menu tile :nudge-right="childMenuNudgeRight">

                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-on="item.children.length > 0 ? on : null" :style="{borderLeft:`6px ${item.color} solid`}" style="padding:0px" :to="item.children.length == 0 ? item.route : null">
                                    <v-icon style="width:49px;height:49px;" size="28">{{item.icon}}</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title style="zoom:.9;">{{item.name}}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="item.children.length > 0">
                                        <v-btn v-on.stop="on" small icon><v-icon>mdi-dots-horizontal</v-icon></v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider />
                            </template>

                            <v-card width="100%">
                                <div v-for="(child, c) in item.children" :key="`nav-child-items-${c}`">
                                    <v-divider v-if="c > 0" />
                                    <router-link class="router-link" :to="child.route" style="text-decoration:none;display:flex;padding:10px 30px 10px 0px;">
                                        <v-icon style="width:49px;">mdi-chevron-right</v-icon>
                                        <span>{{child.name}}</span>
                                    </router-link>
                                </div>
                            </v-card>

                        </v-menu>

                    </div>
                </v-card>

            </div>

            <!-- <v-footer bottom style="padding: 0px" color="transparent" fixed>
                <v-divider />
                <v-list width="100%" dense>
                    <v-list-item :to="item.route" v-for="(item, i) in bottomLinks" :key="i" disabled>
                        <v-list-item-icon>
                            <v-icon size="22">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content v-if="!mini">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-footer> -->
        </scrollable-content>
    </v-navigation-drawer>
</div>
</template>

<script>
import nav from "@/_config/navigation.js";
import appSettings from "@/_mixins/app-settings-mixin";
import uiView from "@/_mixins/ui-view-mixin";
import navAppItem from "@/_components/layouts/nav-app-item";
import userSettings from "@/_mixins/user-settings-mixin";
import logo from "@/_components/layouts/logo";

export default {
    name: "NavigationMain",
    props: {
        value: {
            type: Boolean,
            default: false
        },
    },
    mounted() {
        this.mini = !this.globalNavPinnedOpen;
        this.globalLoadedAnimations = this.globalPinnedApps.slice(0);
    },
    mixins: [userSettings, appSettings, uiView],

    watch: {
        value(newVal) {
            this.drawer = newVal;
        },
        drawer(newVal) {
            this.$emit("input", newVal);
        },
        mini(newValue) {
            this.globalNavPinnedOpen = !newValue;
        },
    },
    components: {
        navAppItem,
        userSettings,
        logo,
    },
    computed: {
        childMenuNudgeRight()
        {
            return this.mini
                ? 56
                : 256;
        },
        route() {
            return this.$route;
        },
        newAppItem() {
            return {
                name: "Add an app",
                route: "/my/newapp",
                icon: "mdi-plus",
                description: "",
            };
        },

        navStyle() {
            var ret = {};

            if (this.$vuetify.breakpoint.lgAndUp) {
                var color = this.globalNavBackgroundColor
                console.log(color);
                ret["background-color"] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
            }
            return ret;
        },
        bottomLinks() {
            return [{
                    text: "Favorites",
                    icon: "mdi-star",
                    route: "/personal/favorites"
                },
                {
                    text: "History",
                    icon: "mdi-history",
                    route: "/personal/history"
                },
            ];
        },
        showNav() {
            return this.value || this.$vuetify.breakpoint.lgAndUp;
        },
        width() {
            var sizes = {
                xs: "100%",
                sm: 400,
                md: 400,
                lg: 350,
                xl: 350,
            };
            return sizes[this.$vuetify.breakpoint.name];
        },
    },
    data() {
        return {
            mini: true,
            drawer: true,
            nav: nav,
            editable: false,
        };
    },
    methods: {
        hide() {
            this.drawer = false;
        },
        handleAppRemove(app) {
            var index = this.globalPinnedApps.indexOf(app.id);
            this.globalPinnedApps.splice(index, 1);
        },
        onDrop(dropResult) {
            var item = this.globalPinnedApps.splice(dropResult.removedIndex, 1);
            this.globalPinnedApps.splice(dropResult.addedIndex, 0, item[0]);
        },
    },
};
</script>

<style lang="scss">
.nav-drawer {
    top: 0px !important;
    height: 100vh !important;
    max-height: 100vh !important;
}
.child-nodes {
    padding: 0px 0px;
    background-color: rgba(0, 0, 0, .25);
}
.router-link,
.router-link * {
    color: white;
    font-family: "Roboto Condensed";
    transition: all .1s ease;
}
.router-link-active {
    font-size: 1.1em;
    font-weight: bold;
    opacity: 1;

}
.router-link {
    margin-left: 0px;
    opacity: .8;

    i {
        visibility: hidden;
    }

}
.router-link.router-link-active {
    opacity: 1;

    i {
        visibility: visible;
    }
}
</style>
